"use client";

import { MapPin, Car, Zap, ShoppingBag } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: Car,
  text: "Kostenlose Parkplätze direkt vor Ort"
}, {
  icon: Zap,
  text: "E-Ladestationen vorhanden"
}, {
  icon: MapPin,
  text: "8 Minuten vom Kasseler Stadtzentrum"
}, {
  icon: ShoppingBag,
  text: "Lebensmittelläden in unmittelbarer Nähe"
}];
export default function CentrallyLocatedWithoutCityStress() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="zentral-gelegen-ohne-innenstadtstress" className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px] overflow-hidden" ref={sectionRef}>
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className={`transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">

        {/* Left: Map */}
        <div className="rounded-2xl overflow-hidden min-h-[600px]">
          <iframe title="BLUVIT GmbH Standort" src="https://maps.google.com/maps?q=Am%20alten%20Rathaus%205a%2034253%20Lohfelden&t=&z=14&ie=UTF8&iwloc=&output=embed" className="w-full h-full min-h-[600px] border-0" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>

        {/* Right: Content */}
        <div className="flex flex-col justify-between py-4 lg:pl-8">
          <div>
            <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Standort</span>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-8">
              <span className="text-[#141414]">Mitten im Leben.</span><br />
              <span className="text-[#888888]">Nicht mitten im Stau.</span>
            </h2>
            <p className="text-lg text-[#555555] leading-relaxed">
              Lohfelden liegt direkt vor den Toren Kassels. Kein Berufsverkehr. Kein Parkhaus. Kein Stress. Du stellst dein Auto kostenlos vor der Tür ab und bist trotzdem in Minuten auf der A7 oder A44.
              <br /><br />
              Und dein E-Auto? Lädt, während du arbeitest.
            </p>
          </div>
          <div className="space-y-6 mt-16">
            {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-4">
                <benefit.icon className="size-5 text-[#888888]" />
                <span className="text-base font-medium text-[#141414]">{benefit.text}</span>
              </div>)}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>;
}